import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    pagesContainer: {
        paddingTop: theme.spacing(2),
    }
}))